import { supabase } from '../lib/supabase';

/**
 * Check if RLS policies are set up correctly
 * Run in console: checkRLS()
 */
export const checkRLS = async () => {
  console.log('🔍 Checking RLS setup for user_profiles...\n');

  try {
    // Check if user is logged in
    const { data: { session } } = await supabase.auth.getSession();
    
    if (!session) {
      console.log('❌ No active session. Please log in first.');
      return;
    }

    console.log('✅ User is logged in');
    console.log('   User ID:', session.user.id);
    console.log('   Email:', session.user.email);

    // Try to fetch profile
    console.log('\n📡 Attempting to fetch profile...');
    const { data, error } = await supabase
      .from('user_profiles')
      .select('*')
      .eq('id', session.user.id)
      .single();

    if (error) {
      if (error.status === 406) {
        console.log('\n❌ 406 ERROR - RLS Policy Issue');
        console.log('   Error:', error.message);
        console.log('\n🔧 SOLUTION:');
        console.log('   1. Go to Supabase Dashboard → SQL Editor');
        console.log('   2. Run the SQL from QUICK_FIX_406.sql');
        console.log('   3. Refresh this page');
      } else if (error.code === 'PGRST116') {
        console.log('\n✅ RLS is working! Profile just doesn\'t exist yet.');
        console.log('   This is normal for new users.');
      } else {
        console.log('\n❌ Error:', error);
      }
    } else {
      console.log('\n✅ SUCCESS! Profile fetched correctly.');
      console.log('   Profile data:', data);
    }

    return { success: !error || error.code === 'PGRST116', error, data };
  } catch (err) {
    console.error('❌ Check failed:', err);
    return { success: false, error: err };
  }
};

// Make it available globally
if (typeof window !== 'undefined') {
  window.checkRLS = checkRLS;
}


